<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<sf-group-wrapper :label="getMessage_('QWCC001170')">
						<el-date-picker :value="searchParams.stdDt" @input="changeSearchDate" format="yyyy-MM-dd" value-format="yyyyMMdd" />
					</sf-group-wrapper>
				</el-col>
				<el-col :span="3">
					<search-input :label="getMessage_('QWCC000956')" paramKey="partNo" @commInput="setSearchParam" :propData="searchParams.partNo" />
				</el-col>
			</el-row>
			<template slot="button">
				<!--초기화-->
				<!-- <sf-button line :onClick="() => searchInit()" v-if="isButton_(scrId, 'CR')" class="icon-sf-refresh">
					{{ getMessage_('QWCC001109') }}
				</sf-button> -->
				<!--조회-->
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchInput },
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return yup.object().shape({});
		}
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		changeSearchDate(value) {
			this.setSearchParam_({ key: 'stdDt', value });
		},
		//조회 이벤트
		searchList() {
			const searchParams = this.searchParams;
			//벨리데이션 체크
			try {
				this.insVali.validateSync(searchParams);
			} catch (error) {
				const today = this.$moment().format('YYYY-MM-DD'); //오늘날짜
				this.changeSearchDate(today);
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				return error;
			}
			this.$sf_toggleLoading(true);
			this.getAsPartInfo_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			//this.setStateClear_();
		},
		//초기화 이벤트
		searchInit() {
			this.setSearchInit_();
		}
	},
	async created() {
		try {
			this.searchDate = this.$moment(this.getstdDt_).format('YYYY-MM-DD');
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
